import { IContentInfo } from '../../ts/models/IContentInfo';
import { IUserInfo } from '../../ts/models/IUserInfo';
import { IViewBase } from '../../ts/models/IViewInfo';
import { IOwnedItemInfo } from '../../ts/models/resourceInfoParts';
import { SiteRolesResource } from '../../ts/resources/SiteRoles';
import { Views } from '../../ts/resources/Views';
import { IDatasourceActions } from '../../ts/ServerApi/types/IDatasourceActions';
import { IWorkbookActions } from '../../ts/ServerApi/types/IWorkbookActions';
import { SessionSiteSelectors, SessionUserSelectors } from '../selectors/SessionInfoSelectors';
import { AppState } from '../state/AppState';

export function getOwnerIdForView(item: IContentInfo | IViewBase): string {
  if (!item) {
    return null;
  }
  if (Views.isViewBase(item)) {
    return (item.workbook && item.workbook.owner) ? item.workbook.owner.id : null;
  }
  return item.owner ? item.owner.id : null;
}

export function isOwnedItemInfo(item: any): item is IOwnedItemInfo {
  return item && item.hasOwnProperty('owner');
}

export function getOwnerForItem(item: any): IUserInfo {
  if (isOwnedItemInfo(item)) {
    return item.owner;
  }
  return null;
}

export function currentUserIsOwnerOrAdmin(state: AppState, item: any): boolean {
  const owner = getOwnerForItem(item);
  const ownerId = owner && owner.id;
  return SessionUserSelectors.isSessionServerAdmin(state)
    || SiteRolesResource.isSiteAdmin(SessionSiteSelectors.siteRole(state))
    || ownerId === SessionUserSelectors.sessionUserId(state);
}

export function hasExtractRefreshPermission(
  state: AppState,
  item: any,
  availableActions: IWorkbookActions | IDatasourceActions,
): boolean {
  return currentUserIsOwnerOrAdmin(state, item)
    || (availableActions && availableActions.refreshExtract);
}
